import React, { useEffect, useState } from "react";
import Icon from "../../../assets/Icon";
import { Segmented } from "antd";
import "../../../styles/twoWayNav.css";
import Utils from "../../utils/Utils";
import { reportDownloadCountPostApi } from "../../../api";

function TwoWayReportNav({
  config,
  switchSystem,
  setSwitchSystem,
  auth,
  interviewId,
}) {
  // const handleChange = (value) => {
  //   console.log(value);
  //   setSwitchSystem(value);
  // };
  const [ip, setIp] = useState();

  const countApi = async (auth, reqbody) => {
    const url = `${reportDownloadCountPostApi}?interviewId=${interviewId}`;
    // let url
    try {
      // setLoading(true);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth,
        },
        body: JSON.stringify(reqbody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
    } catch (err) {
      console.error("Fetch error: ", err);
    } finally {
      // setLoading(false);
    }
  };
  const printReport = () => {
    let reqCount = {
      role: "",
      name: "",
      osType: Utils.detectOS(),
      osVersion: Utils.getOSVersion(),
      browserType: Utils.browserCheck(),
      browserVersion: Utils.browserVersionCheck(),
      ipAddress: ip,
      systemSpecs: {},
      dateTimeInfo: new Date().toISOString().slice(0, -5),
      logCode: "Report download",
      logMessage: "Report download done",
    };
    countApi(auth, reqCount);
    window.print();
  };
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIp(data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);
  
  return (
    <>
      <button
        onClick={printReport}
        className="print-btn px-[.8rem] py-2 text-[#FCFCFD] bg-[#206DC5] flex items-center gap-2 fixed right-5 top-[3%] rounded-md z-10"
      >
        <Icon type="download-icon" color="white" width="18" height="18" />
        <span className="hide-nav-text font-medium text-[.94rem]">
          Print Report{" "}
        </span>
      </button>
      <div className="md:px-4 px-2 py-[.1rem] text-[white] flex gap-2 justify-between items-center shadow bg-[#103662] border-b border-b-[#D0D5DD]">
        <div className="flex gap-[.7rem] items-center">
          {config?.whiteLabelingRequired ? (
            <img
              alt="logo"
              // src="https://hireplusplus-public-de.s3.eu-central-1.amazonaws.com/thubLogo/Logo.png"
              src={config?.whiteLabelingLink}
              className="h-[75px]"
              onError={(e) => {
                e.target.onerror = null; // Prevents infinite loop in case the fallback fails
                e.target.style.display = "none"; // Hides the broken image
                e.target.nextSibling.style.display = "block"; // Shows the default icon
              }}
            />
          ) : (
            <Icon type="hire-logo" width="82" height="70" />
          )}
          <div style={{ display: "none" }}>
            <Icon type="hire-logo" width="82" height="70" />
          </div>

          <div className="flex flex-col">
            <div className="font-semibold text-[1.02rem] md:text-[1.08rem]">
              Skill Assessment Report
            </div>
            <div className="nav-footer-text text-[.77rem] md:text-[.83rem] leading-[1.2rem] font-medium">
              AI Assessment Report by Hire++ <span className="print:inline md:inline hidden">| © HirePlusPlus Technologies Private
              Limited. All Rights Reserved.</span>
            </div>
          </div>
        </div>

        <div className="flex gap-x-6">
          <div className="switch-section min-[1100px]:block hidden">
            <Segmented
              options={[
                {
                  label: "System Analysis",
                  value: true,
                },
                {
                  label: "Editable version",
                  value: false,
                },
              ]}
              value={switchSystem}
              onChange={(value) => {
                setSwitchSystem(value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="switch-mobile-section min-[1100px]:hidden block sm:px-[.8rem] md:px-[1.75rem] px-[.5rem] pt-3">
        <Segmented
          options={[
            {
              label: "System Analysis",
              value: true,
            },
            {
              label: "Editable version",
              value: false,
            },
          ]}
          value={switchSystem}
          onChange={(value) => {
            setSwitchSystem(value);
          }}
        />
      </div>
    </>
  );
}

export default TwoWayReportNav;
